import React, { useEffect, useState } from "react";
import axios from "../../../../apis/Api";
import { useLocation } from "react-router-dom";
import { Image } from "react-bootstrap";
import logo from "../../../../assets/Images/Vizlink_logo.png";

function useQuery() {
  debugger;
  return new URLSearchParams(useLocation().search);
}

const ConfirmEmail = () => {
  const query = useQuery();
  const _token = query.get("token");
  const userId = query.get("userId");
  const _email = query.get("email");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const confirmEmail = async () => {
      let request = {
        id: userId,
        email: _email,
        token: _token,
      };

      try {
        const response = await axios.post(
          `api/Authenticate/EmailConfirmation`,
          request
        );
        if (response.status === 200) {
          setStatus("success");
        } else {
          setStatus("error");
        }
      } catch (error) {
        setStatus("error");
      }
    };

    if (_token && userId) {
      confirmEmail();
    } else {
      setStatus("invalid");
    }
  }, [_token, userId]);

  return (
    <div style={styles.container}>
      <style>
        {`
          @keyframes stroke {
            to { stroke-dashoffset: 0; }
          }

          @keyframes scale {
            0%, 100% { transform: none; }
            50% { transform: scale(1.1); }
          }

          .icon {
            width: 200px;
            height: 200px;
            stroke-width: 4;
            stroke-miterlimit: 10;
            stroke-linecap: round;
            animation: scale 0.3s ease-in-out 0.9s both;
          }

          .circle {
            stroke-dasharray: 166;
            stroke-dashoffset: 166;
            animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
          }

          .check {
            stroke-dasharray: 48;
            stroke-dashoffset: 48;
            animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;
          }

          .x1, .x2 {
            stroke-dasharray: 22;
            stroke-dashoffset: 22;
            animation: stroke 0.3s ease forwards;
          }

          .x2 {
            animation-delay: 0.4s;
          }
        `}
      </style>
      <div
        style={{ textAlign: "center", marginTop: "5rem", marginBottom: "5rem" }}
      >
        <Image className="brand-image" src={logo} alt="Logo"></Image>
      </div>
      {status === "loading" && <p>Confirming your email...</p>}

      {status === "success" && (
        <div style={{ textAlign: "center" }}>
          <svg
            className="icon"
            style={{ stroke: "#4caf50" }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -2 50 58"
          >
            <circle className="circle" cx="26" cy="26" r="25" fill="none" />
            <path className="check" fill="none" d="M14 27l7 7 16-16" />
          </svg>
          <p style={{ color: "#4caf50", marginTop: "1rem" }}>
            Your email has been confirmed!
          </p>
        </div>
      )}

      {(status === "error" || status === "invalid") && (
        <div style={{ textAlign: "center" }}>
          <svg
            className="icon"
            style={{ stroke: "#f44336" }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -2 50 58"
          >
            <circle className="circle" cx="26" cy="26" r="25" fill="none" />
            <path className="x1" fill="none" d="M16 16 36 36" />
            <path className="x2" fill="none" d="M36 16 16 36" />
          </svg>
          <p style={{ color: "#f44336", marginTop: "1rem" }}>
            {status === "error"
              ? "Failed to confirm email. Please try again later."
              : "Invalid confirmation link."}
          </p>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "5rem",
  },
};

export default ConfirmEmail;
